export default __webpack_public_path__ + "static/media/chevrons-up.12823833.svg";